<div [ngClass]="{'col-12 col-xl-6' : !allSettings}">
  <div class="card">
    <div class="card-header">
      <div class="row g-2 align-items-center">
        <div class="col-12 col-xl-8">
          <div class="row g-2 align-items-center">
            <div class="col-12 col-md-4">
              <h5 class="card-title mb-0">{{ 'weeklySchedule' | translate }}</h5>
              <h6 class="card-subtitle text-muted mt-1">{{ 'adjustWeeklySchedule' | translate }}</h6>
            </div>

            <div class="col-12 col-md-4 d-flex justify-content-md-center">
              <div class="d-flex align-items-center gap-3 flex-wrap justify-content-center">
                <app-out-buttons [numOutputs]="outputCount" (outputChange)="onOutputChange($event)"></app-out-buttons>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-xl-4 d-flex justify-content-center justify-content-xl-end">
          <div class="btn-group btn-group-sm" role="group" [attr.aria-label]="'viewMode' | translate">
            <button type="button" class="btn" (click)="viewMode = 'scheduler'"
              [ngClass]="viewMode === 'scheduler' ? 'btn-secondary' : 'btn-outline-secondary'">
              {{ 'programs' | translate }}
            </button>
            <button type="button" class="btn" (click)="viewMode = 'holiday'"
              [ngClass]="viewMode === 'holiday' ? 'btn-secondary' : 'btn-outline-secondary'">
              {{ 'periods' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body pt-0">
      <form>
        <div class="row g-3 align-items-stretch">
          <div class="col-12">
            <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between gap-3 mt-1 w-100">
              <div class="d-flex align-items-center gap-2 ms-4">
                <button type="button" class="btn btn-sm btn-link text-secondary p-0" (click)="shiftSunDate(-1)" [title]="'previousDay' | translate">
                  <i class="fa-solid fa-chevron-left"></i>
                </button>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  style="max-width: 150px;"
                  [(ngModel)]="selectedSunDate"
                  (change)="onSunDateChange()">
                <button type="button" class="btn btn-sm btn-link text-secondary p-0" (click)="shiftSunDate(1)" [title]="'nextDay' | translate">
                  <i class="fa-solid fa-chevron-right"></i>
                </button>
                <button type="button" class="btn btn-sm btn-link text-secondary p-0" (click)="goToTodaySunDate()" [title]="'today' | translate">
                  <i class="fa-solid fa-rotate-left"></i>
                </button>
              </div>

              <div class="d-flex align-items-center flex-wrap gap-2 ms-lg-auto">
                <div class="d-inline-flex align-items-center gap-2 px-2 py-2 border rounded-3 bg-white shadow-sm">
                  <div class="d-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 text-primary"
                    style="width: 30px; height: 30px;">
                    <i class="fa-regular fa-clock small"></i>
                  </div>
                  <div class="d-flex flex-column lh-sm">
                    <small class="text-muted text-center">{{ 'dlTodayRelayLabel' | translate:{ channel: selectedOutput } }}</small>
                    <span class="fw-semibold text-dark">{{ todayResult?.channels?.[selectedOutput]?.totalHours ?? '--' }} h <small class="text-muted fw-normal">{{ 'operatingHours' | translate }}</small></span>
                  </div>
                </div>
                <div class="d-inline-flex align-items-center gap-2 px-2 py-2 border rounded-3 bg-white shadow-sm">
                  <div class="d-flex align-items-center justify-content-center rounded-circle bg-secondary bg-opacity-10 text-secondary"
                    style="width: 30px; height: 30px;">
                    <i class="fa-regular fa-calendar-days small"></i>
                  </div>
                  <div class="d-flex flex-column lh-sm">
                    <small class="text-muted text-center">{{ 'dlAnnualRelayLabel' | translate:{ channel: selectedOutput } }}</small>
                    <span class="fw-semibold text-dark">{{ totalsResult?.channels?.[selectedOutput]?.totalHours ?? '--' }} h <small class="text-muted fw-normal">{{ 'operatingHours' | translate }}</small></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-xl-6 d-flex flex-column mt-0">
            <div class="py-2 flex-fill" [hidden]="hideSchedulerAnc">
              <app-scheduler-anc
                [schedulerData]="scheduleData"
                [outputCount]="outputCount"
                [selectedOutput]="selectedOutput"
                [sunTimesData]="sunTimesData"
                [showLegend]="false"
                [serial]="device"
                [HolidayData]="holidayData"
                [hoveredProgramId]="hoveredProgramId"
                (schedulerDragChange)="onSchedulerDragChange($event)"
                chartIdPrefix="chart-anc1">
              </app-scheduler-anc>
            </div>
          </div>

          <div class="col-12 col-xl-6 d-flex flex-column mt-0">
            <div *ngIf="viewMode === 'holiday'">
              <div class="border rounded-2 mt-4 p-3 w-100 flex-fill d-flex flex-column">
                <div class="d-flex align-items-center justify-content-center gap-2 pb-3"
                  [ngClass]="holidayData && holidayData.periods && holidayData.periods.length > 0 ? 'flex-grow-1' : 'mb-3'">
                  <div *ngIf="holidayData?.periods && holidayEnable" class="text-muted small mb-0">
                    {{ 'holidayClickCalendarHint' | translate }}
                  </div>

                  <button *ngIf="holidayEnable" type="button" class="btn btn-link p-0 text-primary"
                    (click)="openCalendarModal()" [attr.aria-label]="'openCalendar' | translate" [title]="'openCalendar' | translate">
                    <i class="fa-solid fa-calendar-days fs-4"></i>
                  </button>
                </div>

                <div [ngClass]="holidayData && holidayData.periods.length > 0 ? 'mt-auto' : ''">
                  <ng-container *ngIf="holidayData && holidayData?.periods?.length > 0; else emptyState">
                    <div class="d-flex flex-column gap-2">
                      <ng-container *ngFor="let period of holidayData.periods; let i = index">
                        <button type="button" *ngIf="period.enable"
                          class="btn text-start p-3 rounded-3 border d-flex align-items-center gap-3">
                          <div class="d-flex align-items-center justify-content-center rounded-circle text-white flex-shrink-0 lh-1 shadow-sm border border-white"
                            [ngClass]="i === 0 ? 'bg-primary' : i === 1 ? 'bg-success' : i === 2 ? 'bg-danger' : 'bg-secondary'"
                            style="width: 1.75rem; height: 1.75rem; font-size: 0.8rem;"
                            [attr.aria-label]="('holidayPeriod' | translate) + ' ' + (i + 1)">
                            <span class="fw-semibold">{{ i + 1 }}</span>
                          </div>

                          <div class="flex-grow-1">
                            <div class="fw-semibold text-dark">{{ 'holidayPeriod' | translate }} {{ i + 1 }}</div>
                            <div class="text-muted small">
                              {{ period.startDay }}/{{ period.startMonth }} · {{ period.startHourStr }}
                              →
                              {{ period.endDay }}/{{ period.endMonth }} · {{ period.endHourStr }}
                            </div>
                          </div>

                          <div class="d-flex gap-2">
                            <i class="fa-solid fa-pen-to-square" (click)="openCalendarModal(i); changesHoliday = true;"></i>
                            <i class="fa-solid fa-trash text-danger" (click)="deletePeriod(i);"></i>
                          </div>
                        </button>
                      </ng-container>

                      <button type="button" (click)="addPeriod()"
                        class="btn btn-outline-primary w-100 py-3 rounded-3 d-flex align-items-center justify-content-center gap-2"
                        style="border-style: dashed;">
                        <i class="fa-solid fa-plus"></i>
                        <span>{{ 'addPeriod' | translate }}</span>
                      </button>
                    </div>
                  </ng-container>

                  <ng-template #emptyState>
                    <div class="d-flex flex-column align-items-center text-center text-muted mb-3 pb-5">
                      <i class="fa-solid fa-calendar-days fs-2 mb-2"></i>
                      <div class="small">{{ 'noHolidayPeriodsActive' | translate }}</div>
                    </div>
                    <button type="button" (click)="addPeriod()"
                      class="btn btn-outline-secondary w-100 py-3 rounded-3 d-flex align-items-center justify-content-center gap-2"
                      style="border-style: dashed;">
                      <i class="fa-solid fa-plus"></i>
                      <span>{{ 'addPeriod' | translate }}</span>
                    </button>
                  </ng-template>

                  <div>
                    <div class="mt-auto mb-4 d-flex justify-content-end gap-2">
                      <button type="button" [disabled]="!changesHoliday"
                        class="col-6 mt-4 btn btn-light d-inline-flex align-items-center justify-content-center"
                        (click)="restoreHoliday()">
                        <span>{{ 'restore' | translate }}</span>
                      </button>

                      <button type="button" [disabled]="!changesHoliday"
                        class="col-6 mt-4 btn btn-primary d-inline-flex align-items-center justify-content-center"
                        (click)="saveHoliday()">
                        <span class="spinner-border spinner-border-sm text-white me-2" role="status" *ngIf="loading">
                          <span class="visually-hidden">{{ 'loading' | translate }}</span>
                        </span>
                        <span>{{ 'save' | translate }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="viewMode === 'scheduler'" class="flex-fill d-flex flex-column">
              <div class="table-responsive mt-3 pt-3">
                <table class="table table-sm table-striped align-middle mb-0">
                  <thead>
                    <tr>
                      <th class="text-nowrap">#</th>
                      <th class="text-nowrap">{{ 'type' | translate }}</th>
                      <th class="text-nowrap">{{ 'channel' | translate }}</th>
                      <th class="text-nowrap">{{ 'programSection_action' | translate }}</th>
                      <th class="text-nowrap">{{ 'time' | translate }}</th>
                      <th class="text-nowrap">{{ 'correction' | translate }}</th>
                      <th class="text-nowrap">{{ 'weekDays' | translate }}</th>
                      <th class="text-nowrap">{{ 'period' | translate }}</th>
                      <th class="text-nowrap">{{ 'action' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngIf="programDataFormated.length === 0">
                      <td colspan="9">
                        <div class="py-4 text-center text-muted">
                          <i class="fa-solid fa-list-check fs-2 d-block mb-2"></i>
                          <div class="fw-semibold">{{ 'programsEmpty' | translate }}</div>
                          <div class="small">{{ 'programsAddHint' | translate }}</div>
                        </div>
                      </td>
                    </tr>

                    <tr *ngFor="let item of programDataFormated; let i = index"
                      [class.table-drag-updated]="highlightedProgramIndex === i"
                      [class.table-program-edited]="isProgramEdited(item.id)"
                      (mouseenter)="onProgramRowEnter(item)"
                      (mouseleave)="onProgramRowLeave()">

                      <ng-container *ngIf="item.id !== -1">
                        <td class="text-nowrap">
                          <span>{{ item.id + 1 }}</span>
                        </td>

                        <td class="text-nowrap">
                          <div>{{ getTypeLabel(item.type) }}</div>
                          <select name="type" id="type{{ item.id }}" [(ngModel)]="item.type" *ngIf="item.edit">
                            <option [ngValue]="0">{{ 'off' | translate }}</option>
                            <option [ngValue]="1">{{ 'on' | translate }}</option>
                          </select>
                        </td>

                        <td class="text-nowrap">
                          <div>{{ getChannelLabel(item.channel) }}</div>
                        </td>

                        <td class="text-nowrap">
                          <div>{{ getModeLabel(item.mode) }}</div>
                        </td>

                        <td class="text-nowrap">
                          <div *ngIf="item.mode == 1">
                            {{ sunTimesData?.[0]?.sunsetStr }}
                          </div>
                          <div *ngIf="item.mode == 2">
                            {{ sunTimesData?.[0]?.sunriseStr }}
                          </div>
                          <div *ngIf="!item.edit && (item.mode != 1 && item.mode != 2)">
                            {{ _utils.getDateFromMinutes(item.time) }}
                          </div>
                          <input type="time" class="form-control form-control-sm" [(ngModel)]="item.timeStr"
                            *ngIf="item.edit && (item.mode == 16 || item.mode == 4 || item.mode == 8)">
                        </td>

                        <td class="text-nowrap">
                          <div *ngIf="(item.mode == 1 || item.mode == 2)">
                            {{ _utils.getDateFromMinutes(item.time) }}
                          </div>
                          <div *ngIf="(item.mode != 1 && item.mode != 2)">
                            -
                          </div>
                        </td>

                        <td>
                          <div class="d-flex align-items-center flex-wrap gap-1" *ngIf="!item.edit">
                            <span *ngFor="let day of daysOfWeek" class="badge rounded-pill"
                              style="width: 20px; height: 20px;"
                              [ngClass]="isDaySelected(item.daymask, day.value) ? 'bg-primary text-white' : 'bg-secondary bg-opacity-10 text-muted'"
                              [attr.title]="getDayLabel(day.index)">
                              {{ day.short }}
                            </span>
                          </div>
                        </td>

                        <td class="text-nowrap">
                          <div>
                            {{ item.festive == 0 ? '-' : item.festive }}
                          </div>
                          <select name="festive" id="festive" [(ngModel)]="item.festive" *ngIf="item.edit">
                            <option [ngValue]="0">-</option>
                            <option [ngValue]="1">P1</option>
                            <option [ngValue]="2">P2</option>
                            <option [ngValue]="3">P3</option>
                            <option [ngValue]="4">P4</option>
                          </select>
                        </td>

                        <td>
                          <div class="d-flex align-items-center gap-2">
                            <button type="button" class="btn btn-sm btn-link p-0 text-primary"
                              [attr.aria-label]="'editSchedule' | translate" [title]="'edit' | translate"
                              (click)="setEditProgramIndex(i); newProgram = false;" data-bs-toggle="modal"
                              data-bs-target="#editProgram">
                              <i class="fas fa-edit"></i>
                            </button>
                            <button type="button" class="btn btn-sm btn-link p-0 text-danger" (click)="deleteProgram(i)"
                              [attr.aria-label]="'deleteScheduleAria' | translate" [title]="'delete' | translate">
                              <i class="fa-solid fa-trash"></i>
                            </button>
                          </div>
                        </td>
                      </ng-container>
                    </tr>
                  </tbody>
                </table>

                <div class="d-flex justify-content-end mt-3">
                  <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#editProgram"
                    (click)="addProgram(); newProgram = true;">
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>

              <div class="mt-auto mb-4 d-flex justify-content-end gap-2">
                <button type="button" [disabled]="!changesProgram"
                  class="col-6 mt-4 btn btn-light d-inline-flex align-items-center justify-content-center"
                  (click)="restoreProgram()">
                  <span>{{ 'restore' | translate }}</span>
                </button>

                <button type="button" [disabled]="!changesProgram"
                  class="col-6 mt-4 btn btn-primary d-inline-flex align-items-center justify-content-center"
                  (click)="saveProgram()">
                  <span class="spinner-border spinner-border-sm text-white me-2" role="status" *ngIf="loading">
                    <span class="visually-hidden">{{ 'loading' | translate }}</span>
                  </span>
                  <span>{{ 'save' | translate }}</span>
                </button>
              </div>

              <div class="alert alert-danger alert-dismissible mt-3" role="alert" *ngIf="error != ''">
                <div class="alert-message">
                  <i class="fas fa-exclamation-triangle me-2"></i>
                  {{ error }}
                </div>
              </div>
              <div class="alert alert-success alert-dismissible mt-3" role="alert" *ngIf="successMessage && !anyError">
                <div class="alert-message">
                  <i class="fas fa-check-circle me-2"></i>
                  {{ 'updatedSuccesfully' | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade edit-program-modal" id="editProgram" tabindex="-1" aria-labelledby="editProgramLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="!newProgram" class="modal-title" id="editProgramLabel">
          {{ 'editProgramTitle' | translate:{ number: (editProgramIndex ?? 0) + 1 } }}
        </h5>
        <h5 *ngIf="newProgram" class="modal-title" id="editProgramLabel">{{ 'newProgramTitle' | translate }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" [attr.aria-label]="'close' | translate"></button>
      </div>

      <div class="modal-body">
        <ng-container *ngIf="editProgramDraft as draft">
          <div class="row g-3">
            <div class="col-12">
              <div class="d-flex align-items-center justify-content-center flex-wrap gap-2">
                <label class="form-label mb-0">{{ 'weekDays' | translate }}</label>
              </div>
              <div class="d-flex align-items-center justify-content-center flex-wrap gap-2 mt-2">
                <button type="button"
                  class="btn btn-sm btn-outline-primary rounded-pill d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm"
                  (click)="setQuickPreset('weekdays')">
                  <i class="fas fa-briefcase"></i>
                  <span class="fw-semibold">{{ 'workdays' | translate }}</span>
                </button>
                <button type="button"
                  class="btn btn-sm btn-outline-primary rounded-pill d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm"
                  (click)="setQuickPreset('weekend')">
                  <i class="fas fa-bed"></i>
                  <span class="fw-semibold">{{ 'weekend' | translate }}</span>
                </button>
                <button type="button"
                  class="btn btn-sm btn-outline-primary rounded-pill d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm"
                  (click)="setQuickPreset('allDays')">
                  <i class="fas fa-calendar"></i>
                  <span class="fw-semibold">{{ 'allDays' | translate }}</span>
                </button>
              </div>

              <div class="d-flex align-items-center justify-content-center flex-wrap gap-2 mt-2">
                <button *ngFor="let day of daysOfWeek" type="button"
                  class="btn rounded-circle d-inline-flex align-items-center justify-content-center p-0"
                  style="width: 34px; height: 34px;"
                  [ngClass]="isDaySelected(draft.daymask, day.value) ? 'btn-primary' : 'btn-outline-secondary'"
                  [attr.title]="getDayLabel(day.index)" (click)="toggleDay(draft, day.value)">
                  <span class="fw-semibold">{{ day.short }}</span>
                </button>
              </div>
            </div>

            <div class="col-12 col-md-4">
              <label class="form-label" for="editProgramType">{{ 'type' | translate }}</label>
              <select class="form-select" id="editProgramType" name="editProgramType" [(ngModel)]="draft.type">
                <option [ngValue]="0">{{ 'off' | translate }}</option>
                <option [ngValue]="1">{{ 'on' | translate }}</option>
                <!-- <option [ngValue]="2">{{ 'programKind_pulse' | translate }}</option>
                <option [ngValue]="3">{{ 'programKind_cycle' | translate }}</option> -->
              </select>
            </div>

            <div class="col-12 col-md-4">
              <label class="form-label" for="editProgramChannel">{{ 'channel' | translate }}</label>
              <select class="form-select" id="editProgramChannel" name="editProgramChannel" [(ngModel)]="draft.channel">
                <option [ngValue]="1">C1</option>
                <option *ngIf="outputCount > 1" [ngValue]="2">C2</option>
                <option *ngIf="outputCount > 1" [ngValue]="3">{{ 'channelBoth' | translate }}</option>
              </select>
            </div>

            <div class="col-12 col-md-4">
              <label class="form-label" for="editProgramMode">{{ 'programSection_action' | translate }}</label>
              <select class="form-select" id="editProgramMode" name="editProgramMode" [(ngModel)]="draft.mode">
                <option [ngValue]="16">{{ 'fixedTime' | translate }}</option>
                <option [ngValue]="1">{{ 'sunset' | translate }}</option>
                <option [ngValue]="2">{{ 'sunrise' | translate }}</option>
                <option [ngValue]="4">{{ 'programKind_reductionIni' | translate }}</option>
                <option [ngValue]="8">{{ 'programKind_reductionEnd' | translate }}</option>
              </select>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="editProgramFixedTime">{{ 'time' | translate }}</label>
              <ng-container *ngIf="draft.mode === 16 || draft.mode === 4 || draft.mode === 8; else sunReference">
                <input type="time" class="form-control" id="editProgramFixedTime" name="editProgramFixedTime"
                  [(ngModel)]="draft.fixedTimeStr">
                <div class="form-text">{{ 'programFixedTimeHint' | translate }}</div>
              </ng-container>
              <ng-template #sunReference>
                <div class="form-control bg-body-tertiary">
                  <ng-container *ngIf="draft.mode === 1">{{ 'sunset' | translate }}: {{ sunTimesData?.[0]?.sunsetStr || '--:--' }}</ng-container>
                  <ng-container *ngIf="draft.mode === 2">{{ 'sunrise' | translate }}: {{ sunTimesData?.[0]?.sunriseStr || '--:--' }}</ng-container>
                  <ng-container *ngIf="draft.mode !== 1 && draft.mode !== 2 && draft.mode !== 4 && draft.mode !== 8">—</ng-container>
                </div>
                <div class="form-text">{{ 'programSunReferenceHint' | translate }}</div>
              </ng-template>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">{{ 'correction' | translate }}</label>
              <div class="row g-2">
                <div class="col-4">
                  <select class="form-select" name="editProgramCorrectionSign" [(ngModel)]="draft.correctionSign"
                    [disabled]="draft.mode !== 1 && draft.mode !== 2">
                    <option [ngValue]="1">+</option>
                    <option [ngValue]="-1">-</option>
                  </select>
                </div>
                <div class="col-8">
                  <input type="time" class="form-control" name="editProgramCorrection" [(ngModel)]="draft.correctionStr"
                    [disabled]="draft.mode !== 1 && draft.mode !== 2">
                </div>
              </div>
              <div class="form-text">{{ 'programCorrectionHint' | translate }}</div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="editProgramPeriod">{{ 'period' | translate }}</label>
              <select class="form-select" id="editProgramPeriod" name="editProgramPeriod" [(ngModel)]="draft.festive">
                <option [ngValue]="0">-</option>
                <option [ngValue]="1">P1</option>
                <option [ngValue]="2">P2</option>
                <option [ngValue]="3">P3</option>
                <option [ngValue]="4">P4</option>
              </select>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="modal-footer">
        <div class="w-100 d-flex align-items-start gap-2 text-start mb-2"
          *ngIf="editProgramDraft?.mode === 4 || editProgramDraft?.mode === 8">
          <i class="fa-solid fa-circle-info text-primary mt-1"></i>
          <small class="mb-0 text-body">
            <ng-container *ngIf="editProgramDraft?.mode === 4">
              <strong>{{ 'programKind_redIni' | translate }}:</strong> {{ 'programReductionIniHint' | translate }}
            </ng-container>
            <ng-container *ngIf="editProgramDraft?.mode === 8">
              <strong>{{ 'programKind_redEnd' | translate }}:</strong> {{ 'programReductionEndHint' | translate }}
            </ng-container>
          </small>
        </div>

        <div class="w-100 d-flex justify-content-end gap-2">
          <button *ngIf="newProgram" type="button" class="btn btn-outline-secondary" (click)="cancelNewProgram()"
            data-bs-dismiss="modal">{{ 'cancel' | translate }}</button>
          <button *ngIf="!newProgram" type="button" class="btn btn-outline-secondary"
            data-bs-dismiss="modal">{{ 'cancel' | translate }}</button>
          <button type="button" class="btn btn-primary" (click)="saveEditProgram()" data-bs-dismiss="modal">
            {{ 'tourConnectivitySaveTitle' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
